import { getBrowserType } from "../core/utils.js";

export function initCTAPartner() {
    const idleCallback =
        window.requestIdleCallback ||
        function (cb) {
            setTimeout(cb, 1);
        };

    idleCallback(() => {
        const campaignRaw = document.cookie.split("; ").find((row) => row.startsWith("campaign_info="));

        const deviceRaw = document.cookie.split("; ").find((row) => row.startsWith("devicetype="));

        let campaignInfo = {};
        if (campaignRaw) {
            try {
                campaignInfo = JSON.parse(decodeURIComponent(campaignRaw.split("=")[1]));
            } catch (e) {
                console.warn("Invalid campaign_info cookie format");
            }
        }

        const device = /android|iphone|ipad|mobile/i.test(navigator.userAgent) ? "mobile" : "desktop";

        const links = document.querySelectorAll("a.cta-partner");
        links.forEach((link) => {
            const url = new URL(link.href, window.location.origin);
            let hasParam = false;

            if (campaignInfo.utm_source) {
                url.searchParams.set("utm_source", campaignInfo.utm_source);
                hasParam = true;
            }
            if (campaignInfo.utm_medium) {
                url.searchParams.set("utm_medium", campaignInfo.utm_medium);
                hasParam = true;
            }
            if (campaignInfo.utm_campaign) {
                url.searchParams.set("utm_campaign", campaignInfo.utm_campaign);
                hasParam = true;
            }
            if (campaignInfo.gclid) {
                url.searchParams.set("gclid", campaignInfo.gclid);
                hasParam = true;
            }
            if (device) {
                url.searchParams.set("device", device);
                hasParam = true;
            }

            if (hasParam) {
                link.href = url.toString();
            }
        });
    });
}
